import { getBusiness, getUser } from './helpers';


export const roles = {
  superadmin: "superadmin",
  admin: "admin",
  user: "user"
}

export const isAuth = () => {
  if (sessionStorage.getItem('user')) {
    return JSON.parse(sessionStorage.getItem('user'));
  }
  return null;
};

export const isUserAdmin = () => {
  if (sessionStorage.getItem('user')) {
    const role = JSON.parse(sessionStorage.getItem('user')).role;
    if (role === roles.admin || role === roles.superadmin) {
      return true;
    };
  }
  return false;
};

export const isUserSuperadmin = () => {
  if (sessionStorage.getItem('user')) {
    const role = JSON.parse(sessionStorage.getItem('user')).role;
    if (role === roles.superadmin) {
      return true;
    };
  }
  return false;
};

export const changeBusiness = async (id) => {
    const business = await getBusiness(id);
    const user = await getUser();
    user.business = business;
    sessionStorage.setItem("user", JSON.stringify(user));
};

export const logout = async () => {
  removeCookie('token');
  sessionStorage.removeItem("user");
};

export const setCookie = (key, value) => {
  sessionStorage.setItem(key, value);
};

export const getCookie = key => {
  return sessionStorage.getItem(key);
};

export const removeCookie = key => {
  sessionStorage.removeItem(key);
};